import { COLORS } from "./readOnlyStyles";

/** The thresholds the student was graded on live, so a review never recolours a play. */
export const ACCURACY_THRESHOLD_EXCELLENT = 85;
export const ACCURACY_THRESHOLD_MISS = 60;

export function getScoreColor(score: number): string {
  if (score >= ACCURACY_THRESHOLD_EXCELLENT) return COLORS.success;
  if (score >= ACCURACY_THRESHOLD_MISS) return COLORS.warning;
  return COLORS.error;
}

/**
 * Indices in `syllables` where a new word of `text` begins, so a multi-word prompt keeps its
 * spaces when its syllables are rendered back as one continuous string.
 */
export function getWordBoundaryIndices(text: string, syllables: string[]): Set<number> {
  const boundaries = new Set<number>();
  const words = text.split(/\s+/).filter(Boolean);
  let idx = 0;

  for (let wordIndex = 0; wordIndex < words.length; wordIndex++) {
    if (wordIndex > 0) boundaries.add(idx);
    const target = (words[wordIndex] ?? "").toLowerCase().replace(/[^a-z]/g, "");
    let acc = "";
    while (idx < syllables.length && acc !== target) {
      acc += (syllables[idx] ?? "").toLowerCase().replace(/[^a-z]/g, "");
      idx++;
    }
  }

  return boundaries;
}
